import { useMemo } from 'react'
import { easingDefinitionToFunction } from 'motion-utils'

export interface EasingCurvePoint {
  t: number
  value: number
}

export interface EasingCurveData {
  points: EasingCurvePoint[]
  maxValue: number
  minValue: number
}

export function useEasingCurveData(ease: string): EasingCurveData {
  return useMemo(() => {
    const easingFn = easingDefinitionToFunction(ease as any)
    const numPoints = 100
    const points: EasingCurvePoint[] = []
    let maxValue = 1
    let minValue = 0

    for (let i = 0; i <= numPoints; i++) {
      const t = i / numPoints
      const value = easingFn(t)
      points.push({ t, value })
      if (value > maxValue) maxValue = value
      if (value < minValue) minValue = value
    }

    return { points, maxValue, minValue }
  }, [ease])
}
